export default {
  evaluation_list: {
    title: 'รายชื่อซัพพลายเออร์',
    number_of_companies_answered: 'ส่งแล้ว: {answered}/{total} บริษัท',
    number_of_companies_displayed: 'แสดง {start}〜{end} / {total} บริษัท',
    company_name: 'ชื่อบริษัท',
    status: 'สถานะ',
    questionnaire: 'แบบสอบถาม',
    plan: 'วางแผน',
    nothing: 'ไม่พบผลลัพธ์',
  },
  evidence_options: {
    all_plan: 'แผนทั้งหมด',
    plans_with_vouchers: 'มีหลักฐาน',
    no_voucher_plan: 'ไม่มีหลักฐาน',
  },
  table_headers: {
    company_name: 'ชื่อบริษัท',
    status: 'สถานะ',
    esg_rating: 'การจัดอันดับ ESG',
    esg_score: 'คะแนน ESG',
    environment: 'สภาพแวดล้อม',
    social: 'โซเชียล',
    governance: 'ธรรมาภิบาล',
    plan: 'วางแผน',
    questionnaire: 'แบบสอบถาม',
    answer_date: 'วันที่ส่ง',
    answer_expires_date: 'กำหนดเส้นตาย',
  },
  plan_list: {
    light: 'แผน Light',
    starter: 'แผน Starter',
    basic: 'แผน Basic',
    standard: 'แผน Standard',
    enterprize: 'แผน Enterprize',
  },
}
